import type { FragmentType } from '@packages/gql/generated/shopping';
import type { ProductPowerSupplyFragmentFragmentDoc } from '@packages/gql/generated/shopping/ProductPowerSupplyFragmentFragmentDoc';
import { unmask } from '@packages/gql/src/betterMasking';
import {
  PowerSupplyLocalized,
  type PowerSupplyLocalizedProps,
} from '../PowerSupplyLocalized/PowerSupplyLocalized';

/* GraphQL */ `
  fragment ProductPowerSupplyFragment on PowerSupply {
    maxPower
    minPower
    chargerType
    powerSupplyIncluded
  }
`;

export type ProductPowerSupplyProps = {
  maskedData: FragmentType<typeof ProductPowerSupplyFragmentFragmentDoc>;
} & Pick<PowerSupplyLocalizedProps, 'asCard' | 'showPowerSupplyMessage'>;

export const ProductPowerSupply = ({ maskedData, ...rest }: ProductPowerSupplyProps) => {
  const { maxPower, minPower, chargerType, powerSupplyIncluded } =
    unmask<typeof ProductPowerSupplyFragmentFragmentDoc>(maskedData);

  return (
    <PowerSupplyLocalized
      maxPower={maxPower}
      minPower={minPower}
      chargerType={chargerType}
      powerSupplyIncluded={powerSupplyIncluded}
      {...rest}
    />
  );
};
